
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import CustomTagMixin from '@/@next/mixins/CustomTag';
import { CLazyLoadingImage } from '@/components/images';
import { CLoader } from '@/components/loader';
import CModal from '@/components/modal';
import { CImage } from '@/@next/components/image';
import { CButton } from '@/components/form-controls/button';
import _shuffle from 'lodash/shuffle';
import _cloneDeep from 'lodash/cloneDeep';
import Medias from '@/@next/services/Medias';
import { messages } from '@/@next/i18n';
import { TimelineContentData } from '@/@types/graphql';
import CContentTimelineEvent from './TimelineContentEvent.vue'
import CTimelineFullScreen from './TimelineFullScreen.vue'

const config = {
  name: 'c-content-timeline',
  i18n: { messages },
  components: {
    CLazyLoadingImage,
    CLoader,
    CImage,
    ...CModal,
    CButton,
    CContentTimelineEvent,
    CTimelineFullScreen
  }
};

@Component(config)
export default class CContentTimeline extends Mixins(CustomTagMixin, Medias) {
  @Prop({ type: Object, required: true }) content!: any;
  @Prop({ type: String, required: false, default: '' }) contextId!: string;

  showDescription: boolean = false;
  showTimeLineFullScreen: boolean = false;
  currentEventSelected: number = 0;

  @Watch('currentEventSelected')
  onCurrentIndexChanged () {
    const container = document.getElementById('timeline-events');
    if (!container) return
    const item = document.getElementById(`event-${this.currentEventSelected}`);
    if (!item) return
    const containerWidth = container.offsetWidth;
    const itemWidth = item.offsetWidth;
    const itemOffsetLeft = item.offsetLeft;
    const scrollLeft = itemOffsetLeft - (containerWidth - itemWidth) / 2;
    container.scrollLeft = scrollLeft;
  }

  get timeline (): TimelineContentData {
    return this.content.data
  }

  get title () {
    return (
      this.timeline?.i18n?.title?.value || {
        text: 'Timeline',
        html: 'Timeline'
      }
    );
  }

  get text () {
    return this.timeline?.i18n?.text?.value || null;
  }

  get events () {
    return this.timeline?.events || [];
  }

  selectEvent (i: number) {
    console.log('select event  ', i)
    this.currentEventSelected = i;
    this.showTimeLineFullScreen = true;
  }

}
